import { SvgProps } from "./Form";

export const SmallSparkle = (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_7280_7259)">
      <path
        d="M5.33322 9.07867L4.25156 6.915L2.08789 5.83333L4.25156 4.75167L5.33322 2.588L6.41489 4.75167L8.57856 5.83333L6.41489 6.915L5.33322 9.07867ZM3.57856 5.83333L4.74822 6.41833L5.33322 7.588L5.91822 6.41833L7.08789 5.83333L5.91822 5.24833L5.33322 4.07867L4.74822 5.24833L3.57856 5.83333ZM7.99989 9L8.49989 10L8.99989 9L9.99989 8.5L8.99989 8L8.49989 7L7.99989 8L6.99989 8.5L7.99989 9ZM8.44422 3.55567L8.83322 4.33333L9.22222 3.55567L9.99989 3.16667L9.22222 2.77767L8.83322 2L8.44422 2.77767L7.66656 3.16667L8.44422 3.55567Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7280_7259">
        <rect width="8" height="8" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
